// Ícono de usuario, extraído del JSX para no ensuciar la vista.
// (El mismo SVG está en Home.jsx: se puede mover a components/icons/ para deduplicar.)
export default function IconoUsuario({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}
